import { Link } from 'react-router-dom'
import { COMPANY } from '../constants/company'

const footerLinks = [
  { label: 'Funcionalidades', href: '/#como-funciona' },
  { label: 'Preços', href: '/#precos' },
  { label: 'Blog', href: '/blog' },
  { label: 'Suporte', href: '/suporte' },
  { label: 'Privacidade', href: '/privacidade' },
  { label: 'Termos', href: '/termos' },
]

export default function Footer() {
  return (
    <footer className="px-5 py-10 border-t border-neutral-200 lg:px-16 lg:py-12">
      <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-6 sm:gap-5 lg:flex-nowrap">
      <Link to="/" className="no-underline">
        <img src="/waitherelogo.png" alt="Waithere" className="h-6 w-auto" />
      </Link>
      <ul className="flex gap-5 lg:gap-7 list-none flex-wrap">
        {footerLinks.map((link) => (
          <li key={link.label}>
            <Link to={link.href} className="text-sm text-neutral-400 no-underline hover:text-black transition-colors">
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
      <div className="flex items-center gap-4 sm:ml-auto">
        <a
          href="https://www.facebook.com/share/1Nusjwxxz3/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-neutral-400 hover:text-[#1877F2] transition-colors"
          aria-label="Facebook"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
          </svg>
        </a>
        <a
          href="https://www.instagram.com/waithere.br"
          target="_blank"
          rel="noopener noreferrer"
          className="text-neutral-400 hover:text-[#E4405F] transition-colors"
          aria-label="Instagram"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.054 1.97.24 2.43.403a4.088 4.088 0 011.47.957c.453.453.757.91.957 1.47.163.46.349 1.26.404 2.43.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.055 1.17-.241 1.97-.404 2.43a4.088 4.088 0 01-.957 1.47 4.088 4.088 0 01-1.47.957c-.46.163-1.26.349-2.43.404-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.055-1.97-.241-2.43-.404a4.088 4.088 0 01-1.47-.957 4.088 4.088 0 01-.957-1.47c-.163-.46-.349-1.26-.404-2.43C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.055-1.17.241-1.97.404-2.43a4.088 4.088 0 01.957-1.47A4.088 4.088 0 015.064 2.3c.46-.163 1.26-.349 2.43-.404C8.76 1.838 9.14 1.826 12 1.826V2.163zm0 1.802c-3.15 0-3.504.012-4.742.068-1.145.053-1.766.244-2.18.405a3.283 3.283 0 00-1.216.79 3.283 3.283 0 00-.79 1.216c-.161.414-.352 1.035-.405 2.18C2.613 9.862 2.6 10.216 2.6 12s.013 2.138.067 3.376c.053 1.145.244 1.766.405 2.18.19.487.444.936.79 1.216.28.346.729.6 1.216.79.414.161 1.035.352 2.18.405 1.238.055 1.592.067 4.742.067s3.504-.012 4.742-.067c1.145-.053 1.766-.244 2.18-.405a3.508 3.508 0 002.006-2.006c.161-.414.352-1.035.405-2.18.055-1.238.067-1.592.067-4.742s-.012-3.504-.067-4.742c-.053-1.145-.244-1.766-.405-2.18a3.283 3.283 0 00-.79-1.216 3.283 3.283 0 00-1.216-.79c-.414-.161-1.035-.352-2.18-.405C15.504 3.977 15.15 3.965 12 3.965zM12 6.838a5.162 5.162 0 110 10.324 5.162 5.162 0 010-10.324zm0 1.802a3.36 3.36 0 100 6.72 3.36 3.36 0 000-6.72zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" />
          </svg>
        </a>
        <a
          href="https://wa.me/5547984916254"
          target="_blank"
          rel="noopener noreferrer"
          className="text-neutral-400 hover:text-[#25D366] transition-colors"
          aria-label="WhatsApp"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
        </a>
        <span className="text-[13px] text-neutral-400">
          © 2026 {COMPANY.brandName}. Feito no Brasil 🇧🇷
        </span>
      </div>
      </div>
      <p className="mt-6 pt-6 border-t border-neutral-100 text-xs text-neutral-400 text-center sm:text-left">
        {COMPANY.brandName} é operado por {COMPANY.legalName} · CNPJ {COMPANY.cnpj}
      </p>
    </footer>
  )
}
